import appConfig from '@frontend/env';
import { hydraShellService } from '../services';

export function shouldRedirectToSSO(ssoTenant: string): boolean {
  const showAuthTenantSSO = appConfig.SHOW_AUTH_TENANT_SSO === 'true';
  const currentLoginState = hydraShellService.getCurrentState();
  return showAuthTenantSSO && !!ssoTenant && (currentLoginState === 'login' || currentLoginState === 'none');
}
